const routes = [
  {
    path: 'login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '@/view/authentication/SignIn.vue'),
  },
  {
    path: 'register',
    name: 'register',
    component: () => import(/* webpackChunkName: "register" */ '@/view/authentication/Signup.vue'),
  },
  {
    path: 'forgot-password',
    name: 'forgotPassword',
    component: () => import(/* webpackChunkName: "forgotPassword" */ '@/view/authentication/ForgotPassword.vue'),
  },
  {
    path: 'first-login',
    name: 'firstLogin',
    component: () => import(/* webpackChunkName: "firstLogin" */ '@/view/authentication/FirstLogin.vue'),
  },
  {
    path: 'update-password',
    name: 'updatePassword',
    component: () => import(/* webpackChunkName: "updatePassword" */ '@/view/authentication/UpdatePassword.vue'),
  },
];

export default routes;
